/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_back': {
    width: 23,
    height: 36,
    viewBox: '0 0 23 36',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M18.64.525l3.38 3.38L7.664 18.263 22.021 32.62 18.64 36 .903 18.263 18.641.525z" _fill="#000"/>'
  }
})
